import React from "react";
import { Button, Input, Form, AutoComplete, message, Icon, Tooltip, Modal } from 'antd';
import NHFormItem from "../common/NHFormItem";
import NHSelect from "../common/NHSelect";
import NHFetch from "../../utils/NHFetch";
import PropTypes from 'prop-types';
import createHashHistory from 'history/createHashHistory'
import { hasAuth } from "../../utils/NHCore";
import { readCard } from '../../utils/readCard';


let add = '';
const FormItem = Form.Item;
const Option = AutoComplete.Option;
const basicUrl = '/yxxc/';
const hashHistory = createHashHistory();

class HeaderSearchPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false, //是否正在查询
            mrzhlx: '', //默认帐号类型
            dataSource: [], //备选数据源
            inputType: 'normal', //查询框类型
            tooltipVisiable: false, //切换查询框类型提示
        }
    }

    componentDidMount() {
        //默认搜索输入框获取焦点
        const searchInput = this.searchInput;
        searchInput.focus();

        //获取默认帐号类型
        NHFetch(basicUrl + 'getYxxtMrzhlx', 'GET')
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        this.setState({ mrzhlx: data });
                    }
                }
            });

    }

    componentWillUnmount() {
        //销毁读卡器
        if (add) {
            add.stop();
        }
    }


    //流程ID变化时，清空自动补全备选项
    componentWillReceiveProps(nextProps) {
        if ('lcid' in nextProps) {
            this.setState({ dataSource: [] });
        }
    }

    componentWillUnmount() {

    }

    handlePressEnter = () => {
        this.search();
    }

    //帐号类型变化回调
    handleSelectChange = () => {
        //清空自动补全备选项
        this.setState({ dataSource: [] });
    }

    //自动完成输入框选中事件
    handleAutoCompleteSelect = (value, option) => {
        this.search(value);
    }

    //动态补全
    handleAutoCompleteSearch = (value) => {
        if (value) {
            const form = this.props.form;
            form.validateFields((err, formData) => {
                if (err) {
                    return;
                }
                formData.zh = value;
                NHFetch(basicUrl + 'getStudentInfoByFuzzyQuery', 'GET', formData)
                    .then(res => {
                        if (res) {
                            let data = res.data;
                            if (data) {
                                this.setState({ dataSource: data });
                            } else {
                                this.setState({ dataSource: [] });
                            }
                        }
                    });
            });
        } else {
            this.setState({ dataSource: [] });
        }
    }

    //切换查询框类型
    handleSwap = () => {

        let { inputType } = this.state;

        if (inputType == 'auto') {
            this.setState({ inputType: 'normal', tooltipVisiable: true });
        } else {
            this.setState({ inputType: 'auto', tooltipVisiable: true });
        }

        // setTimeout(() => {
        //     this.setState({ tooltipVisiable: false })
        // }, 1000);

    }

    //点击查询按钮回调
    handleSearchBtnClick = () => {
        this.search();
    }

    //查询
    search = (value) => {
        const form = this.props.form;
        const onSearch = this.props.onSearch;
        if (value) {
            form.validateFields((err, formData) => {
                if (err) {
                    return;
                }
                if (onSearch) {
                    formData.zh = value;
                    this.setState({ loading: true });
                    onSearch(formData, () => { this.setState({ loading: false }) });
                }
            });
        } else {
            form.validateFields((err, formData) => {
                if (err) {
                    return;
                }
                if (onSearch && formData.zh) {
                    this.setState({ loading: true });
                    onSearch(formData, () => { this.setState({ loading: false }) });
                }
            });
        }

        //默认搜索输入框获取焦点
        const searchInput = this.searchInput;
        if (searchInput) {
            searchInput.focus();
        }
    }

    // //自动读卡
    // autoReadIdCard = () => {

    //     // 新中新身份证读卡器，所有项目地默认
    //     try {
    //         let flag = SynCardOcx1.FindReader(); //自动寻找计算机连接的读卡器,大于0成功
    //         if (flag > 0) {
    //             SynCardOcx1.SetLoopTime(1000); //监听cardin事件时间间隔
    //             SynCardOcx1.SetReadType(1); //自动读卡
    //             if (SynCardOcx1.addEventListener) {//所有主流浏览器，除了 IE 8 及更早 IE版本
    //                 SynCardOcx1.addEventListener("CardIn", function (State) { }, false);
    //             } else if (SynCardOcx1.attachEvent) {// IE 8 及更早 IE 版本
    //                 SynCardOcx1.attachEvent("onCardIn", function (State) { });
    //             }
    //         } else {
    //             message.warn('没有找到读卡器！1、请检查设备与计算机连接是否正常。2.请检查机具驱动安装是否正确。');
    //         }
    //     } catch (e) {
    //         message.warn('浏览器不支持读卡，请切换至IE浏览器或检查机具驱动安装是否正确！');
    //     }
    // }

    // //手动读卡
    // manualReadIdCard = () => {

    //     // 新中新身份证读卡器，所有项目地默认
    //     try {
    //         let flag = SynCardOcx1.FindReader(); //自动寻找计算机连接的读卡器,大于0成功
    //         if (flag > 0) {
    //             SynCardOcx1.SetReadType(0);
    //             let nRet = SynCardOcx1.ReadCardMsg();
    //             //等于0读卡成功
    //             if (nRet == 0) {
    //                 let sfzh = SynCardOcx1.CardNo;
    //                 const { setFieldsValue } = this.props.form;
    //                 setFieldsValue({ zhlx: 'sfzjh', zh: sfzh });
    //                 this.search();
    //             } else {
    //                 message.warn('没有找到身份证，请放置身份证！');
    //             }
    //         } else {
    //             message.warn('没有找到读卡器！1、请检查设备与计算机连接是否正常。2.请检查机具驱动安装是否正确。');
    //         }
    //     } catch (e) {
    //         message.warn('浏览器不支持读卡，请切换至IE浏览器或检查机具驱动安装是否正确！');
    //     }
    // }

    //自动读卡2
    autoReadIdCard = () => {
        add = readCard((data) => {
            const { setFieldsValue } = this.props.form;
            setFieldsValue({ zhlx: 'sfzjh', zh: data.cardno });
            this.search();
        });
        add.start(); //开启
        add.check();
        // add.stop(); //关闭
    }

    //手动读卡2
    manualReadIdCard = () => {
        fetch('http://127.0.0.1:8989/api/ReadMsg').then(response => response.json())
            .then((data) => {
                if (data) {
                    if (data.retmsg == "读居民身份证操作失败") {
                        message.warn('没有找到身份证，请放置身份证！');
                    } else {
                        const { setFieldsValue } = this.props.form;
                        setFieldsValue({ zhlx: 'sfzjh', zh: data.cardno });
                        this.search();
                    }
                } else {
                    message.warn('没有找到读卡器！1、请检查设备与计算机连接是否正常。2.请检查机具驱动安装是否正确');
                }
            }).catch(e => Modal.error({ title: '错误信息', content: '没有找到读卡器！1、请检查设备与计算机连接是否正常。2.请检查机具驱动安装是否正确' }))
    }



    //重置
    handleReset = () => {
        const form = this.props.form;
        form.setFieldsValue({ zhlx: this.state.mrzhlx, zh: '' });
        this.setState({ dataSource: [] }, () => {

            //默认搜索输入框获取焦点
            const searchInput = this.searchInput;
            if (searchInput) {
                searchInput.focus();
            }
        });

    }

    // 清除搜索框的值
    clear = () => {
        const form = this.props.form;
        form.setFieldsValue({ zh: '' });
        this.setState({ dataSource: [] }, () => {
            //默认搜索输入框获取焦点
            const searchInput = this.searchInput;
            if (searchInput) {
                searchInput.focus();
            }
        });
    }

    render() {
        const form = this.props.form;
        const { loading, mrzhlx, dataSource, inputType, tooltipVisiable } = this.state;

        const children = dataSource.map((item) => {
            return (
                <Option key={item.ZH}>
                    {item.XM}
                    <span style={{ position: 'absolute', right: 12 }}>{item.ZH}</span>
                </Option>
            );
        });

        return (
            <div>
                <Form layout="inline">
                    <NHFormItem id={'zhlx'} form={form} label={'帐号类型'} formItemLayout={null} required={true}
                        initialValue={mrzhlx == '' ? 'sfzjh' : mrzhlx}>
                        <NHSelect sign={'dmk_yxxt_zhlx'} style={{ width: 120, border: 0 }} showSearch={false}
                            filterData={{ type: 'remove', filterkeys: [''] }} onChange={this.handleSelectChange} />
                    </NHFormItem>
                    <NHFormItem id={'zh'} form={form} label={'帐号'} formItemLayout={null} required={true}>
                        {
                            inputType == 'auto' ?
                                <AutoComplete
                                    ref={input => this.searchInput = input}
                                    style={{ width: 220 }}
                                    dropdownMatchSelectWidth={false}
                                    dropdownStyle={{ width: 250 }}
                                    autoFocus={true}
                                    defaultActiveFirstOption={true}
                                    optionLabelProp={'value'}
                                    placeholder="请输入帐号"
                                    dataSource={children}
                                    onSelect={this.handleAutoCompleteSelect}
                                    onSearch={this.handleAutoCompleteSearch}
                                >
                                    <Input addonAfter={(
                                        <Tooltip placement="top" title={'自动读取帐号'} >
                                            <Icon type="down" theme="outlined" style={{ cursor: 'pointer' }} onClick={this.handleSwap} />
                                        </Tooltip>
                                    )} />
                                </AutoComplete>
                                :
                                <Input
                                    ref={input => this.searchInput = input}
                                    style={{ width: 220 }}
                                    placeholder="请输入帐号"
                                    autoFocus={true}
                                    onPressEnter={this.handlePressEnter}
                                    addonAfter={(
                                        <Tooltip placement="top" title={'手动输入帐号'} >
                                            <Icon type="up" theme="outlined" style={{ cursor: 'pointer' }} onClick={this.handleSwap} />
                                        </Tooltip>
                                    )} />
                        }
                    </NHFormItem>
                    <FormItem>
                        <Button type="primary" onClick={this.handleSearchBtnClick} loading={loading}> 查询 </Button>&nbsp;&nbsp;
                        {hasAuth('zhxg_yxgl_yxxc:autoRead') ? <Button type="primary" style={{ marginRight: '8px' }} ghost onClick={this.autoReadIdCard}>自动读卡</Button> : ''}
                        {hasAuth('zhxg_yxgl_yxxc:manualRead') ? <Button type="primary" style={{ marginRight: '8px' }} ghost onClick={this.manualReadIdCard}>手动读卡</Button> : ''}
                        <Button onClick={this.handleReset}>重置</Button>
                    </FormItem>
                </Form>
            </div>
        )
    }
}

const HeaderSearch = Form.create()(HeaderSearchPage);

HeaderSearchPage.propTypes = {
    lcid: PropTypes.string, //当前流程ID
    onSearch: PropTypes.func.isRequired, //搜索回调
}
export default HeaderSearch


// WEBPACK FOOTER //
// ./components/yxxc/headerSearch.js